import { InferOutput, number } from 'valibot'

export const FuelSchema = number()

export type Fuel = InferOutput<typeof FuelSchema>

export const MAX_START_TURN_ADD_FUEL = 100
